module.exports = __webpack_public_path__ + "img/CZ61858374.8aecc863.png";